<!--
 * @Description: 历史参与项目列表
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render ref="tableRender" :config="config" height="52vh" />
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
export default {
  name: 'HistoryProject',
  inject: ['indexPage'], // src\page\project-personnel-manage\index.vue
  props: {
    // 接口数据
    userId: {
      type: Number,
      default: 0,
      required: true
    },
    //1-历史参与项目【查看】 2-历史参与项目【设置】
    source: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data() {
    return {
      config: null
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    config[0].childMenu[0].defaultQuery = {
      userId: this.userId,
      source: this.source
    };
    this.config = config;
  }
};
</script>

<style scoped lang="scss"></style>
